/* jshint esversion: 6 */
import React from 'react';
import ChooserButton from 'app/components/SubaccountSelector/ChooserButton.jsx';


class ChooserMain extends React.Component {
    constructor(props) {
        super(props)

        this.generateSelectorList = this.generateSelectorList.bind(this);

    }

    generateSelectorList(list, cssSelector) {
        return (
            <ul className={`detail-list ${cssSelector}`}>
                {list.map((subaccount) => {
                    return (
                        <li key={subaccount[this.props.idField]} className='list-item social chooser'>
                            <ChooserButton
                                buttonDecorator={this.props.buttonDecorator}
                                subaccount={subaccount}
                                idField={this.props.idField}
                                serviceID={this.props.serviceID}
                                onSubaccountClick={this.props.onSubaccountClick}
                                selectedSocials={this.props.selectedSocials}
                                app={this.props.app}/>
                        </li>
                    );
                })}
            </ul>
        );
    }

    render() {
        let nothingAvailable = null,
            allConnected = null,
            available = null,
            inUse = null,
            unverified = null,
            unavailable = null,
            ineligible = null,
            selectAll = null,
            constants = this.props.app.config.constants;

        // no sorted subs? we're not ready to show anything then
        if (Object.keys(this.props.sortedSubs).length === 0) {
            return null;
        }

        if (this.props.sortedSubs.inUseAvailable.length === 0 &&
            this.props.sortedSubs.available.length === 0 &&
            this.props.sortedSubs.unavailable.length === 0) {
            let noSubaccountMessage = (
                <span>
                    {"We were unable to locate any pages associated with your social media account that can be connected to dlvr.it."}<br/><br/>
                    {"This may mean this social media account doesn't have the necessary posting permissions. You may want to log into a different social media account with the necessary management permissions."}
                </span>
            );

            if (this.props.noSubaccountMessage !== undefined) {
                noSubaccountMessage = this.props.noSubaccountMessage
            }

            nothingAvailable = (
                <div className="chooser-notice no-accounts">
                    {noSubaccountMessage}
                </div>
            );
        }

        if (this.props.sortedSubs.available.length === 0 && this.props.sortedSubs.inUseAvailable.length === 0 && this.props.sortedSubs.unavailable > 0) {
            let allConnectedMessage = (
                <span>You've already connected all eligible socials to dlvr.it</span>
            );

            if (this.props.allConnectedMessage) {
                allConnectedMessage = this.props.allConnectedMessage;
            }

            allConnected = (
                <div className="chooser-notice all-connected">
                    {allConnectedMessage}
                </div>
            );
        }

        if (this.props.sortedSubs.available.length) {
            available = this.generateSelectorList(this.props.sortedSubs.available, 'available');
        }

        if (this.props.sortedSubs.inUseAvailable.length) {
            inUse = (
                <div>
                    <div className="chooser-notice">
                        Active in another dlvr.it account. Choose a profile below to move it to this dlvr.it account.
                    </div>
                    {this.generateSelectorList(this.props.sortedSubs.inUseAvailable, 'available-inuse')}
                </div>
            )
        }

        if (this.props.sortedSubs.unverified.length) {
            let unverifiedMessage = this.props.unverifiedMessage || 'These socials have not been verified.';
            unverified = (
                <div>
                    <div className="chooser-notice">
                        {unverifiedMessage}
                    </div>
                    {this.generateSelectorList(this.props.sortedSubs.unverified, 'inuse')}
                </div>
            );
        }

        if (this.props.sortedSubs.unavailable.length) {
            let unavailableMessage = "Socials you've already connected";

            if (this.props.unavailableMessage) {
                unavailableMessage = this.props.unavailableMessage;
            }

            unavailable = (
                <div>
                    <div className="chooser-notice">
                        {unavailableMessage}
                    </div>
                    {this.generateSelectorList(this.props.sortedSubs.unavailable, 'inuse')}
                </div>
            )
        }

        if (this.props.sortedSubs.ineligible.length) {
            let ineligibleMessage = (
                <div className="chooser-notice">
                    "Socials not eligible for posting"
                </div>
            );

            if (this.props.ineligibleMessage) {
                if (typeof(this.props.ineligibleMessage) === "string") {
                    ineligibleMessage = (
                        <div className="chooser-notice">
                            {this.props.ineligibleMessage}
                        </div>
                    );
                } else {
                    ineligibleMessage = this.props.ineligibleMessage;
                }

            }

            ineligible = (
                <div>
                    {ineligibleMessage}
                    {this.generateSelectorList(this.props.sortedSubs.ineligible, 'inuse')}
                </div>
            )
        }

        if (this.props.mode === "POST" &&
            (this.props.sortedSubs.inUseAvailable.length || this.props.sortedSubs.available.length) &&
            this.props.subtype !== constants.FB_SUBTYPE_GROUP) {
            let controlLabel = 'Select All',
                selectAllSubs = true;

            if (this.props.selectedSocials.length === (this.props.sortedSubs.inUseAvailable.length + this.props.sortedSubs.available.length)) {
                controlLabel = 'Select None';
                selectAllSubs = false;
            }

            if (this.props.serviceID !== constants.POST_SVC_DISCORD && [constants.PUB_LEVEL_1, constants.PUB_LEVEL_16, constants.PUB_LEVEL_15].indexOf(this.props.user.detail.pubLevel) === -1) {
                selectAll = (
                    <div className="select-all-subs" onClick={() => {
                            this.props.selectAll(selectAllSubs);
                        }}>
                        {controlLabel}
                    </div>
                );
            }

        }

        return (
            <div>
                <div className="chooser-box">
                    {selectAll}
                    {nothingAvailable}
                    {allConnected}
                    {available}
                    {inUse}
                    {unverified}
                    {unavailable}
                    {ineligible}
                </div>
                {this.props.footerControls}
            </div>
        );
    }
}

ChooserMain.displayName = "ChooserMain";

ChooserMain.defaultProps = {
    buttonDecorator: () => {}
};

export default ChooserMain;
